import React from 'react';

const Hamburger = () => (
  <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="m21.6 17.774c.22 0 .4.224.4.5 0 .245-.142.45-.328.492l-.072.008h-19.2c-.22 0-.4-.224-.4-.5 0-.246.142-.45.328-.492l.072-.008zm0-6.387c.22 0 .4.224.4.5 0 .245-.142.45-.328.492l-.072.008h-19.2c-.22 0-.4-.224-.4-.5 0-.246.142-.45.328-.492l.072-.008zm0-6.387c.22 0 .4.224.4.5 0 .245-.142.45-.328.492l-.072.008h-19.2c-.22 0-.4-.224-.4-.5 0-.245.142-.45.328-.492l.072-.008z"
      fill="#141414"
      fillRule="evenodd"
    />
  </svg>
);

export default Hamburger;
